export const StatChoice = {
  Ror: 0,
  StandardDeviation: 1,
  SharpeRatio: 2,
  SortinoRatio: 3,
  MaxDrawdown: 4,
  Correlation: 5,
  Beta: 6,
  Alpha: 7,
  UpCaptureRatio: 8,
  DownCaptureRatio: 9,
  UpDownCaptureRatio: 10,
};

export const StatOption = {
  StatSummaryOption: 4,
  StatCustomOption:5
};

export const StatType = {
  Analytics: 1,
  MarketData: 3,
};
